export const formatHubspotProperties = (properties) => {
  const formattedProperties = {};

  Object.keys(properties)
    // We only care about actual properties, not the hubspot internal fields.
    .filter((property) => property.indexOf('hs_') != 0)
    .forEach((property) => {
      formattedProperties[property] = properties[property];
    });

  return formattedProperties;
};
